import { React, useState, useEffect } from 'react';
import { MotifIcon, MotifTooltip } from '@ey-xd/motif-react';
import { actionIcInfoOutline24px } from '@ey-xd/motif-react/assets/icons';
import {
  CardTitleTwo,
  DataCardContainerPL,
  TitleContainerTwo,
  DataContainerTwo,
  ValueTwo,
  Separator,
  LabelLineTwo,
} from '../../../../atoms/dashboard/personalDashboard.styles';
import { DATA_CARD_TWO, QUARTERLY_DETAILS } from '../../../../../constants/commonConstants';

// DataCard component
const DataCardTwo = data => {
  const [forecastCompletion, setforecastCompletion] = useState();

  useEffect(async () => {
    if (!!data && data != null && data != undefined) {
      setforecastCompletion(data.data);
    }
  }, [data]);

  return (
    !!forecastCompletion && (
      <DataCardContainerPL>
        <TitleContainerTwo>
          <CardTitleTwo>{DATA_CARD_TWO.FORECAST_COMPLETION}</CardTitleTwo>
          <MotifTooltip
            id="bottom"
            trigger={
              <MotifIcon
                src={actionIcInfoOutline24px}
                style={{ width: '16px', height: '16px', margintop: '3px' }}
              ></MotifIcon>
            }
            allowHover={true}
            allowClick={true}
            placement="bottom"
          >
            Users are expected to submit a <br /> forecast every month – 12 <br /> forecasts each
            fiscal year.
          </MotifTooltip>
          {/* <MotifIcon
            src={actionIcInfoOutline24px}
            style={{ width: '16px', height: '16px', margintop: '3px' }}
          /> */}
        </TitleContainerTwo>
        <DataContainerTwo>
          <ValueTwo>
            {forecastCompletion.Submitted === null
              ? QUARTERLY_DETAILS.NOT_APPLICABLE
              : forecastCompletion.Submitted}
          </ValueTwo>
          <LabelLineTwo>{DATA_CARD_TWO.SUBMITTED}</LabelLineTwo>
        </DataContainerTwo>
        <Separator />
        <DataContainerTwo>
          <ValueTwo>
            {forecastCompletion.Missed === null
              ? QUARTERLY_DETAILS.NOT_APPLICABLE
              : forecastCompletion.Missed}
          </ValueTwo>
          <LabelLineTwo>{DATA_CARD_TWO.MISSED}</LabelLineTwo>
        </DataContainerTwo>
        <Separator />
        <DataContainerTwo>
          <ValueTwo>
            {forecastCompletion.Remaining === null
              ? QUARTERLY_DETAILS.NOT_APPLICABLE
              : forecastCompletion.Remaining}
          </ValueTwo>
          <LabelLineTwo>{DATA_CARD_TWO.REMAINING}</LabelLineTwo>
        </DataContainerTwo>
      </DataCardContainerPL>
    )
  );
};

export default DataCardTwo;
